import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Lora\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-heading\",\"display\":\"swap\"}],\"variableName\":\"lora\"}");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Nunito\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-body\",\"display\":\"swap\"}],\"variableName\":\"nunito\"}");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/opt/buildhome/repo/src/components/AuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/components/GardenReminderToast.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/components/InstallPrompt.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/components/MainWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/components/Navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthGateProvider"] */ "/opt/buildhome/repo/src/context/AuthGateContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BugReportProvider"] */ "/opt/buildhome/repo/src/context/BugReportContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TextSizeProvider"] */ "/opt/buildhome/repo/src/context/TextSizeContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserDataProvider"] */ "/opt/buildhome/repo/src/context/UserDataContext.tsx");
